export const GET_VOICE_AGENT_ANALYSIS_RESULTS = gql`
  query GET_VOICE_AGENT_ANALYSIS_RESULTS(
    $filters: VoiceAgentAnalysisFilters!
    $pageInfo: PageInfoInput!
  ) {
    voiceAgentAnalysisResults(filters: $filters, pageInfo: $pageInfo) {
      items {
        voiceAgentAnalysisResultId
        name
        result
        createdAt
        updatedAt
        activityLog {
          activityLogId
          callDuration
          from
          activityDate
          to
        }
      }
      totalCount
      pageInfo {
        offset
        limit
      }
    }
  }
`

export const GET_VOICE_AGENT_ANALYSIS_TOTALS = gql`
  query GET_VOICE_AGENT_ANALYSIS_TOTALS($filters: VoiceAgentAnalysisFilters!) {
    voiceAgentAnalysisTotals(filters: $filters) {
      name
      count
    }
  }
`

export const GET_VOICE_AGENT_ANALYSIS_DISTRIBUTION = gql`
  query GET_VOICE_AGENT_ANALYSIS_DISTRIBUTION(
    $filters: VoiceAgentAnalysisFilters!
    $limit: Int
  ) {
    voiceAgentAnalysisDistribution(filters: $filters, limit: $limit) {
      voiceAgentAnalysisResultId
      name
      result
      createdAt
      updatedAt
      activityLog {
        activityLogId
        callDuration
        from
        activityDate
        to
      }
    }
  }
`
